import { memoizeByAssetSource } from '@exodus/core-selectors/utils/memoize.js'
import { createSelector } from 'reselect'

const selectorFactory = (availableAssetsSelector, createAssetSourceIncomingOrdersSelector) =>
  memoizeByAssetSource(({ assetName, walletAccount }) =>
    createSelector(
      createAssetSourceIncomingOrdersSelector({ assetName, walletAccount }),
      availableAssetsSelector,
      (incomingOrders, availableAssets) => {
        if (!availableAssets[assetName]) {
          throw new Error('cannot use use selector on unavailable asset')
        }

        const asset = availableAssets[assetName]
        return [...incomingOrders].reduce(
          (acc, next) => acc.add(next.toAmount),
          asset.currency.ZERO
        )
      }
    )
  )
const createAssetSourceIncomingOrdersAmountSelectorDefinition = {
  id: 'createAssetSourceIncomingOrdersAmount',
  selectorFactory,
  dependencies: [
    { module: 'availableAssets', selector: 'all' },
    { selector: 'createAssetSourceIncomingOrders' },
  ],
}

export default createAssetSourceIncomingOrdersAmountSelectorDefinition
